import { Box, Button, Container, FormControl, FormLabel, Heading, Input, Stack, Text, Textarea, useToast } from '@chakra-ui/react'
import React, { useState } from 'react'
import YellowButton from '../components/Buttons/YellowButton'
import SectionHeading from '../components/SectionHeading'
import { POST } from '../utilities/ApiProvider';
import { baseUrl } from '../utilities/customUrls';

export default function UkDonors() {

    return (
        <Stack
            paddingY={'80px'}
        >
            <Container
                maxW={'7xl'}
            >
                <Stack
                    paddingTop={12}
                >
                    <SectionHeading width={'100%'} smallHeading={"Cash & Cross Cheque"} mainHeading={'Cross Cheque'} marginPosition={'auto'} textAlignment={'center'} />
                    <ol>
                        <li>
                            <Text
                                paddingTop={8}
                                paddingBottom={1}
                                maxW={'6xl'}
                                marginX={'auto'}
                                fontSize={'22px'}
                                color={'#748188'}
                            >Transfer directly to the account of UK:</Text>
                        </li>
                        <li>
                            <Text
                                paddingY={1}
                                maxW={'6xl'}
                                marginX={'auto'}
                                fontSize={'22px'}
                                color={'#748188'}
                            >Mujaddid Alf Sani Trust<br />
                                Barclays Bank: A/C # 90893447  <br />
                                Sort Code # 204545 <br /></Text>
                        </li>
                    </ol>
                </Stack>
            </Container>
        </Stack>
    )
}
